// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HDtk0yJl4IWI8b9RqqNx {\n\tmargin-right: 5px;\n\tpadding: 0;\n}\n", "",{"version":3,"sources":["webpack://./client/src/components/ExpenseDetailsCard/private/styles/ExpenseActionButtons.module.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,UAAU;AACX","sourcesContent":[".buttonIcon {\n\tmargin-right: 5px;\n\tpadding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonIcon": "HDtk0yJl4IWI8b9RqqNx"
};
export default ___CSS_LOADER_EXPORT___;
